export enum ThemeEnum {
    LIGHT = "light",
    DARK = "dark",
    SYSTEM = "system",
    DEFAULT = "light"
}

export type ThemeType = typeof ThemeEnum[keyof typeof ThemeEnum]

export interface Options {
	threshold?: number;
	root?: Element | null;
	rootMargin?: string;
}